import React, { useState, useEffect } from "react";
import SEO from "../shared/seo";
import Layout from "../shared/components/organisms/layout/layout";
import '../shared/styles/index.scss';
import EntryKeysContent from "../components/organisms/entry-keys-content/entry-keys-content";
import ModalFidelization from "../components/molecules/modal-fidelization/modal-fidelization"


const EntryKeys = () => {

  // var news_info=props.dataProp
  const [isMobile, setMobileBool] = useState(false);
  // send active modal to layout
  const updateDimensions = () => {
    setMobileBool(window.innerWidth < 1024 ? true : false);
  }

  useEffect(() => {
    updateDimensions();
    window.addEventListener("resize", updateDimensions);
    return () => {
      window.removeEventListener("resize", updateDimensions);
    }
  }, [])

  return (
    <Layout
      mobile={isMobile}
      title="Mis Puntos - Ingreso de claves"
    >
      <SEO
        title="Mis Puntos - Ingreso de claves"
        url={"/mis-puntos/ingreso-de-claves/"}
      />

      <ModalFidelization />


      <EntryKeysContent
        mobile={isMobile}
      />

    </Layout>
  )
}

export default EntryKeys;